import HeaderTabSelector from './HeaderTabSelector.component';

export default HeaderTabSelector;
